// src/routes/EmployeeRoutes.tsx
import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';
import Loader from '../components/Loader';
import hrRoutesConfig from './config/hrRoutesConfig';

const HRRoutes = hrRoutesConfig.map(({ path, component: Component }) => (
  <Route
    key={path}
    path={path}
    element={
      <Suspense fallback={<Loader />}>
        <ProtectedRoute element={<Component />} allowedRoles={['HR', 'Admin']} />
      </Suspense>
    }
  />
));
export default HRRoutes;


